import React from 'react';
// Custom module styles
import classes from '../appScreenControls.module.css';

const AppSideBar = () => {
  return <div className={classes.footer_ticker}>AppSideBar</div>;
};

export default AppSideBar;
